module.exports = __webpack_public_path__ + "static/img/2.7.c6eaa53.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/picture/2.7.jpg
// module id = I1EP
// module chunks = 7